export default "__VITE_ASSET__3e3d2dd6__"